<template>
  <pop-up-layout 
    :title="$t('reservas.contrato.confirmarFirmantes.titulo')"
    :description="$t('reservas.contrato.confirmarFirmantes.descripcion')"
    @volver="$parent.hide()"
    @aceptar="$emit('aceptar');$parent.hide()"
    :aceptar="$t('reservas.contrato.continuar')"
  >
    <o-description-title v-if="pantalla">{{$t('reservas.contrato.representantesPresente')}}</o-description-title>
    <div v-for="(representante, i) in representantes" :key="'representante' + i">
      <o-medium-title>{{representante.representante.nombreApellido}}</o-medium-title>
      <v-layout row wrap>
        <v-flex xs12 md6 px-2>
            <v-text-field
              :label="$t('reservas.formularioFisico.email')"
              :name="'email[' + i + ']'"
              :value="representante.email"
              :disabled="true"
            />
        </v-flex>
        <v-flex xs12 md6>
          <v-text-field
            :name="'numTelefono[' + i + ']'"
            :label="$t('reservas.formularioFisico.telefono')"
            :value="representante.movil"
            :disabled="true"
          />
        </v-flex>
      </v-layout>
    </div>
  </pop-up-layout>
</template>

<script>
export default {
  props: {
    representantes: {
      type: Array,
      required: true
    },
    pantalla: {
      type: Boolean,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reservas/contratos/ContratoConfirmarFirmantes.vue